module.exports = __webpack_public_path__ + "static/media/report.0dff0c6e.svg";